import React from 'react';
import {
  List, Paper, ListItem, ListItemText,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Actions from '../actions';

const getContent = (props, options) => {
  switch (props.item) {
    case 'therapists':
      return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Paper style={{
            maxHeight: 200, overflow: 'auto', width: '500px', margin: 10,
          }}
          >
            <List component="nav" aria-label="All Therapists">
              {options && options.map((option) => {
                return (option
                  ? (
                    <ListItem button key={option._id} onClick={() => { props.therapistSelected(option); }}>
                      <ListItemText primary={option.name} secondary={option.email} />
                    </ListItem>
                  ) : null
                );
              })}
            </List>
          </Paper>
        </div>
      );
    default: return null;
  }
};

const SimpleList = (props) => {
  let options = [];
  if (props.item === 'therapists') {
    options = props.therapists;
  }
  return getContent(props, options);
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    therapists: state.therapist.allTherapists,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SimpleList);
